import React from 'react';
import { Outlet } from 'react-router-dom';
import useMatchMedia from 'hooks/useMatchMedia';
import ResolveHeader from 'components/ResolveHeader';
import Logo from 'components/ResolveHeader/components/Logo';

import './Auth.styles.scss';
import './Auth.styles.responsive.scss';

const AuthRouter: React.FC = () => {
  const isPhablet = useMatchMedia('isPhablet');

  return (
    <section className="auth-section">
      {isPhablet ? (
        <header>
          <Logo />
        </header>
      ) : (
        <ResolveHeader />
      )}
      <main>
        <Outlet />
      </main>
    </section>
  );
};

export default AuthRouter;
